import React , { Component } from "react";
import SEO from '../../components/seo';
import Layout from "../../components/layout";
//import MainBanner from "../../components/whitepaper-infographic/page-main-banner";
import { Link } from "gatsby";
import ImageMainBanner from "../../images/compass-banner.png";
import ImageMainBannerVector from "../../images/infographic-vector.png";
import IconRightArrow from "../../icons/icon-thank-you-arrow-right.svg"
import ImageIndustrySources1 from "../../images/bloomberg-img.svg";
import ImageIndustrySources2 from "../../images/bbc-img.svg";
import ImageIndustrySources3 from "../../images/hbr-img.svg";
import ImageIndustrySources4 from "../../images/mckinsey-img.svg";
import ImageIndustrySources5 from "../../images/world-trade-organization.svg";
import ImageIndustrySources6 from "../../images/cnbc-img.svg";
import BannerSlideIn from "../../components/common/utils/animations/bannerSlideIn";
import IconCheckmarkImage from "../../icons/icon-checkmark.svg";
import LazyLoad from 'react-lazyload';
import { submitForm } from '../../components/common/templates/form/submitForm';
import 'react-phone-input-2/lib/style.css';
import { InView } from 'react-intersection-observer';
import scrollTo from 'gatsby-plugin-smoothscroll';
const emailValidation = RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(?!hotmail|gmail|yahoo|outlook|test|yop|icloud)(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

class WhitePaperInfoGraphic extends Component {
    constructor(props) {
      super(props);
      //this.nameRef = React.createRef();
      this.textInput = null;
      this.referrer = null;
      this.state = {
        name: "",
        nameValidation: "",
        lastName: "",
        email: "",
        emailValidation: "",
        companyname: "",
        companynameValidation: "",
        shouldSubmit: false,
        showSuccess: false,
        submitButtonState: "",
        isInView: false,
        isVisible: true,
      };
    }
    clearFields = () => {
      this.setState({
        name: "",
        nameValidation: "",
        email: "",
        emailValidation: "",
        companyname: "",
        companynameValidation: "",
        shouldSubmit: false,
        showSuccess: false,
        submitButtonState: ""
      });
    };

    componentDidUpdate() {
      this.props.isVisible && this.nameRef.current.focus();
      this.referrer = document.referrer;
    }
  
    checkFields = () => {
      const { nameValidation, emailValidation, companynameValidation } = this.state;
      if (nameValidation === 'success-field' &&
        emailValidation === 'success-field' &&
        companynameValidation === 'success-field') {
        this.setState({
          shouldSubmit: true
        });
      }
      return {
        ...(!nameValidation) && { nameValidation: 'error-field', shouldSubmit: false },
        ...(!emailValidation) && { emailValidation: 'error-field', shouldSubmit: false },
        ...(!companynameValidation) && { companynameValidation: 'error-field', shouldSubmit: false },
      };
    };
  
    onSubmit = (event) => {
      event.preventDefault();
      if (this.state.submitButtonState === '') {
        this.setState(this.checkFields(),
          async () => {
            if (this.state.shouldSubmit) {
              this.setState({
                submitButtonState: "inProgress"
              });
  
              let formData = new FormData();
              formData.append("form_id", 12);
              formData.append("input_1", this.state.name);
              formData.append("input_3", this.state.email);
              formData.append("input_5", this.referrer);
              formData.append("input_6", this.props.location.pathname);
              formData.append("input_7", this.state.companyname);
              formData.append("input_8", this.state.lastName)
              formData.append("input_12", "https://www.rapidops.com/resources/supply-chain-manufacturing-infographic-2022.pdf");
              formData.append("input_13", "Rapidops: Must-Know Trends for Supply Chain & Manufacturing in 2022");
              formData.append("input_14", "2022 Executive Compass for Supply Chain & Manufacturing")
              formData.append("input_15", "EC-MFG-INFOGRAPHIC-2022-AUG-WEB" )
              
              
              const requestData = {
                method: 'post',
                url: 'https://rapidopsbackend.kinsta.cloud/wp-json/gf/v2/forms/12/submissions',
                data: formData
              };
  
              try {
                const response = await submitForm(requestData);
                if (response.status === 200 || response.status === 201) {
                  setTimeout(() => {
                    this.setState({
                      submitButtonState: "finished",
                      isVisible: false
                    });
                  }, 200);
                }
                setTimeout(() => {
                  this.clearFields();
                  this.setState({
                    showSuccess: true
                  })
                }, 200);
              }
              catch (error) {
                console.log(error);
              }
            }
          });
      }
    };
  
  
    handleChange = (e) => {
      const name = e.target ? e.target.name : 'phone';
      const value = e.target ? e.target.value : e;
      switch (name) {
        case 'name':
          if (!value)
            this.setState({
              nameValidation: 'error-field',
              shouldSubmit: false,
            });
          else
            this.setState({
              nameValidation: 'success-field',
            });
          break;
  
  
        case 'email':
          if (!emailValidation.test(value))
            this.setState({
              emailValidation: 'error-field',
              shouldSubmit: false,
            });
          else
            this.setState({
              emailValidation: 'success-field',
            });
          break;
  
  
        case 'companyname':
          if (value.length < 5)
            this.setState({
              companynameValidation: 'error-field',
              shouldSubmit: false,
            });
          else
            this.setState({
              companynameValidation: 'success-field',
            });
          break;
  
        default:
          break;
      }
      const newState = {};
      newState[name] = value;
      this.setState(newState);
    };
  
    nameFocus = () => {
      this.textInput.focus();
    }
  
    inViewChange = (view) => {
      this.setState({
        isInView: view
      })
    }
  
    render() {
      const { nameValidation, emailValidation, companynameValidation, showSuccess, submitButtonState, isInView, isVisible } = this.state;
      return (
        <>
        <Layout addBodyClass="infographic-page transparent-header white-paper-landing-page" footerFormType="basic">
        <SEO description="No-nonsense detailed insights on Manufacturing and Supply Chain opportunities in 2022, carefully curated and extensively researched for all the disrupting leaders out there."
              meta={[{ name: "charSet", content: "utf-8" }]}
              title="Must-Know Trends for Supply Chain & Manufacturing - 2022" />
          <div className="page-main-banner-section page-main-banner-liquid-image section-gap d-flex align-v-center">
            <div className="container">
              <div className="row d-flex flex-wrap justify-space">
                <div className="col page-main-banner-detail">
                  <div className="page-main-banner-detail-inner">
                    <span className="theme-color-title">2022 EXECUTIVE COMPASS </span>
                    <h1 className="h1">Must-Know Trends for Supply Chain & Manufacturing - 2022</h1>
                    <ul>
                      <li>Unlock actionable insights to put your business ahead of the competition</li>
                      <li>Learn how economic scenarios are transforming your industry dynamics</li>
                      <li>Get access to 15+ detailed use cases that you can immediately monetize </li>
                    </ul>
                  </div>
                  <div id="form-section-scroll"></div>
                  <div className="form-section-infographic" id={this.props.id ? this.props.id : "form-section"}>
                    {!showSuccess &&
                      <div className="form-section-infographic-inner">
                        <span className="form-title h3">Download your <span>FREE</span> copy now!</span>
                        <form name="infographic" onSubmit={this.onSubmit} className="fomt-style-round">
                          <div className="form-row has-two-column">
                            <div className="form-column">
                              <input ref={(elem) => (this.textInput = elem)} placeholder="First Name*" type="text" className={`form-input LoNotSensitive ${nameValidation}`} id="name" name="name" autoComplete="off" onChange={this.handleChange} value={this.state.name} tabIndex="1" />
                            </div>
                            <div className="form-column">
                              <input placeholder="Last Name" type="text" className="form-input LoNotSensitive" id="lastName" name="lastName" autoComplete="off" onChange={this.handleChange} value={this.state.lastName} tabIndex="2" />
                            </div>
                          </div>
                          <div className="form-row">
                            <div className="form-column">
                              <input placeholder="Work Email*" type="email" name="email" className={`form-input LoNotSensitive ${emailValidation}`} id="email" autoComplete="off" onChange={this.handleChange} value={this.state.email} tabIndex="3" />
                              <small className={`${emailValidation}`}>Please enter your work email.</small>
  
                            </div>
                          </div>
                          <div className="form-row">
                            <div className="form-column">
                              <input ref={this.nameRef} placeholder="Company*" type="text" className={`form-input LoNotSensitive ${companynameValidation}`} id="companyname" name="companyname" autoComplete="off" onChange={this.handleChange} value={this.state.companyname} tabIndex="4" />
                            </div>
                          </div>
                          <div className="form-action">
                            <button type="submit" className={`button right-arrow button-white  ${submitButtonState}`} tabIndex="5" >
                              <span className="submit">Download</span>
                              <span className="loading"> Download </span>
                              <span className="check"> <IconCheckmarkImage /> </span>
                            </button>
                            <p>By submitting this form you agree to our <Link to="/privacy-policy/">Privacy Policy</Link>.</p>
                          </div>
                        </form>
                      </div>
                    }
                    {showSuccess &&
                      <div className="thank-you-infographics">
                        <h3>Thank you for downloading! </h3>
                        <p>Please check your email for the Infographic on<span className="green-color"> 2022 Executive Compass for Supply Chain & Manufacturing.</span></p>
                        <strong>TAKE THE NEXT STEP &nbsp; <IconRightArrow /> </strong>
                        <p className="mb-40">Want to explore your opportunities with our digital manufacturing and supply chain solutions? Just drop us a line.</p>
                        <Link to="/contact/" className="button right-arrow button-white">Contact Us</Link>
                      </div>
                    }
                  </ div>
                </div>
                <BannerSlideIn classes="col page-main-banner-image">
                  <LazyLoad>
                    <img className="main-img" src={ImageMainBanner} title="Must-Know Trends for Supply Chain & Manufacturing - 2022" alt="Must-Know Trends for Supply Chain & Manufacturing - 2022" />
                    <img className="vector-img" src={ImageMainBannerVector} title="Infographic Supply Chains 4.0" alt="Supply Chains Threats & Opportunities" />
                  </LazyLoad>
                </BannerSlideIn>
              </div>
            </div>
          </div>
          <InView onChange={this.inViewChange}>
            <div className="about-infographic section-gap">
              <div className="container">
                <div className="row d-flex flex-wrap">
                  <div className="col left-side-content">
                    <div className="sources-box">
                      <h4>Get access to 120+ insights from 30+ industry sources </h4>
                      <ul className="industries-sources-list">
                        <li>
                          <LazyLoad>
                            <img src={ImageIndustrySources1} title="industry sources" alt="industry sources" />
                          </LazyLoad>
                        </li>
                        <li>
                          <LazyLoad>
                            <img src={ImageIndustrySources2} title="industry sources" alt="industry sources" />
                          </LazyLoad>
                        </li>
                        <li>
                          <LazyLoad>
                            <img src={ImageIndustrySources3} title="industry sources" alt="industry sources" />
                          </LazyLoad>
                        </li>
                        <li>
                          <LazyLoad>
                            <img src={ImageIndustrySources4} title="industry sources" alt="industry sources" />
                          </LazyLoad>
                        </li>
                        <li>
                          <LazyLoad>
                            <img src={ImageIndustrySources5} title="industry sources" alt="industry sources" />
                          </LazyLoad>
                        </li>
                        <li>
                          <LazyLoad>
                            <img src={ImageIndustrySources6} title="industry sources" alt="industry sources" />
                          </LazyLoad>
                        </li>
                      </ul>
                    </div>
                    <div className="about-company-list">
                      <span className="about-company-list-count">2.1MM</span>
                      <p>estimated unfilled manufacturing jobs in U.S. by 2030</p>
                    </div>
                    <div className="about-company-list">
                      <span className="about-company-list-count">20%</span>
                      <p>CAGR is the expected growth rate of investment in AI by 2025</p>
                    </div>
                  </div>
                  <div className="col right-side-content">
                    <h2>What’s Inside</h2>
  
                    <p>This ‘EXECUTIVE COMPASS’ contains carefully curated and extensively researched insights for all the leaders and decision-makers in the manufacturing, logistics, and supply chain industry. With the chaotic economic scenarios coupled with the supersonic rise in automation and AI-powered intelligence, there is an enormous and never-like-before shift emerging in the industry. We have attempted to make it easier for the executives by providing answers to all the questions that might be racing their minds. These insights will help leaders accelerate the pace of their digital transformation efforts.</p>
  
                    <p>It includes: </p>
  
                    <ul>
                      <li>Top <strong>4</strong> repercussions of Russia - Ukraine war on manufacturing </li>
                      <li><strong>8</strong> reasons for oil prices hike and the aftermath faced by world  </li>
                      <li><strong>8</strong> key causes for chip shortage and its impact on manufacturers  </li>
                      <li>Growth of raw material prices pre and post COVID  </li>
                      <li>Top <strong>3</strong> manufacturing industries that are highly affected by COVID & war </li>
                      <li>Key response by manufacturers to increasing prices and shortages  </li>
                      <li><strong>15+</strong> digital opportunities emerging in the industry  </li>
                      <li>Top <strong>10</strong> monetizable opportunities that executives need to start delivering on</li>
                    </ul>
                    <div className="col left-side-content">
                    <div className="sources-box">
                        <h4>Get access to 120+ insights from 30+ industry sources </h4>
                        <ul className="industries-sources-list">
                          <li>
                            <LazyLoad>
                              <img src={ImageIndustrySources1} title="industry sources" alt="industry sources" />
                            </LazyLoad>
                          </li>
                          <li>
                            <LazyLoad>
                              <img src={ImageIndustrySources2} title="industry sources" alt="industry sources" />
                            </LazyLoad>
                          </li>
                          <li>
                            <LazyLoad>
                              <img src={ImageIndustrySources3} title="industry sources" alt="industry sources" />
                            </LazyLoad>
                          </li>
                          <li>
                            <LazyLoad>
                              <img src={ImageIndustrySources4} title="industry sources" alt="industry sources" />
                            </LazyLoad>
                          </li>
                          <li>
                            <LazyLoad>
                              <img src={ImageIndustrySources5} title="industry sources" alt="industry sources" />
                            </LazyLoad>
                          </li>
                          <li>
                            <LazyLoad>
                              <img src={ImageIndustrySources6} title="industry sources" alt="industry sources" />
                            </LazyLoad>
                          </li>
                        </ul>
                      </div>
                      <div className="about-company-list">
                        <span className="about-company-list-count">94%</span>
                        <p>of <strong>Fortune 1000 companies</strong> experienced supply chain disruptions during the Pandemic</p>
                      </div>
                      <div className="about-company-list">
                        <span className="about-company-list-count">3%</span>
                        <p><strong>shrink</strong> is expected in the global economy by <strong>2024</strong> </p>
                      </div>
                      
                    </div>
                    {isVisible &&
                      <div onClick={() => scrollTo('#form-section-scroll')}><button className="button right-arrow button-white" onClick={this.nameFocus}>Download</button></div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="section-gap">
              <div className="container">
                <div className="dt-cta-section">
                  <div className="dt-cta-inner">
                    <div className="leftbar">
                      <h3>Explore how Rapidops can help you monetize your digital opportunities in manufacturing and supply chain.</h3>
                    </div>
                    <div className="rightbar">
                      <a className="button button-white-border right-arrow" href="/industries/manufacturing/">Learn More</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </InView>
          </Layout>
        </>
      );
    }
  }

export default WhitePaperInfoGraphic;

